import { HStack, Header, Pressable } from '@rbilabs/universal-components';

export const LanguageSelectorContainer = HStack.withConfig({
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '8',
  marginBottom: {
    base: 0,
    md: '8',
  },
  marginX: {
    base: '6%',
    md: '8',
  },
});

export const LanguageSelectorButton = Pressable.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  padding: 0,
});

export const LanguageSelectorText = Header.withConfig({
  paddingX: '2',
  mb: 0,
});
